import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Mail, Eye, Copy } from 'lucide-react';
import { StatusBadge } from '../components/StatusBadge';
import { useWorkspace } from '../contexts/WorkspaceContext';
import { PreviewModal } from '../components/PreviewModal';
import { EmailPreview } from '../components/EmailPreview';
export function EmailTemplates() {
  const {
    templates,
    duplicateTemplate
  } = useWorkspace();
  const [previewTemplate, setPreviewTemplate] = useState<(typeof templates)[0] | null>(null);
  return <div className="space-y-6" data-id="element-1063">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-1064">
        <div className="min-w-0" data-id="element-1065">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1066">
            Email Templates
          </h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-1067">
            Manage double opt-in and confirmation emails.
          </p>
        </div>
        <Link to="/templates/new" className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 whitespace-nowrap flex-shrink-0" data-id="element-1068">
          <Plus className="h-4 w-4 flex-shrink-0" data-id="element-1069" />
          <span data-id="element-1070">Create Template</span>
        </Link>
      </div>

      {templates.length === 0 ? <div className="bg-white border border-gray-200 rounded-lg p-12 text-center" data-id="element-1071">
          <h3 className="mt-2 text-sm font-semibold text-gray-900" data-id="element-1072">
            No templates created
          </h3>
          <p className="mt-1 text-sm text-gray-500" data-id="element-1073">
            Create your first email template to get started.
          </p>
        </div> : <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 lg:gap-6" data-id="element-1074">
          {templates.map(template => <div key={template.id} className="bg-white border border-gray-200 rounded-lg p-4 lg:p-6 hover:shadow-sm transition-shadow flex flex-col" data-id="element-1075">
              <div className="flex items-start justify-between mb-4 gap-3" data-id="element-1076">
                <div className="p-2 bg-blue-50 rounded-lg flex-shrink-0" data-id="element-1077">
                  <Mail className="h-5 w-5 lg:h-6 lg:w-6 text-blue-600" data-id="element-1078" />
                </div>
                <StatusBadge status={template.status} data-id="element-1079" />
              </div>
              <h3 className="text-base lg:text-lg font-medium text-gray-900 mb-1 truncate" data-id="element-1080">
                {template.name}
              </h3>
              <p className="text-sm text-gray-500 mb-4 truncate" data-id="element-1081">
                Subject: {template.subject}
              </p>
              <div className="flex items-center gap-2 pt-4 border-t border-gray-100 mt-auto flex-wrap" data-id="element-1082">
                <Link to={`/templates/${template.id}`} className="text-sm font-medium text-blue-600 hover:text-blue-800 whitespace-nowrap" data-id="element-1083">
                  Edit Template
                </Link>
                <span className="text-gray-300" data-id="element-1084">|</span>
                <button onClick={() => setPreviewTemplate(template)} className="text-sm font-medium text-gray-500 hover:text-gray-700 flex items-center gap-1 whitespace-nowrap" data-id="element-1085">
                  <Eye className="h-3 w-3 flex-shrink-0" data-id="element-1086" /> Preview
                </button>
                <span className="text-gray-300" data-id="element-1087">|</span>
                <button onClick={() => duplicateTemplate(template.id)} className="text-sm font-medium text-gray-500 hover:text-gray-700 flex items-center gap-1 whitespace-nowrap" data-id="element-1088">
                  <Copy className="h-3 w-3 flex-shrink-0" data-id="element-1089" /> Duplicate
                </button>
              </div>
            </div>)}
        </div>}

      <PreviewModal isOpen={!!previewTemplate} onClose={() => setPreviewTemplate(null)} title={`Preview: ${previewTemplate?.name}`} data-id="element-1090">
        {previewTemplate && <EmailPreview subject={previewTemplate.subject} html={previewTemplate.html} data-id="element-1091" />}
      </PreviewModal>
    </div>;
}